import type { WebWidgetModel } from '@web/types';
import type { FigureEntity } from '@sites/entity-core';

import { Widgets } from '@common/enums';
import { defaultWidgetParams, defaultWidgetPermission } from '@common/constants';
import { createFigure } from '@sites/entity-core';

import { FigureViewComponent } from '../components/figure-view/figure-view.component';
import { FigureControlComponent } from '../components/figure-control/figure-control.component';

// DEFAULT COMPONENT SETTINGS — sourced from the canonical entity factory in
// @sites/entity-core. Figure is zero-only (`params.type: ['zero']`), so the
// data factory ignores `meta` — there is a single shape, and the envelope's
// `type: 'zero'` tag is stamped by `WebWidgetsFactoryService.createSignalFormWidget`
// from `meta.type`.
const figureData = (): FigureEntity['data'] => createFigure().data;
// END DEFAULT SETTINGS

export const figureWidgetModel: WebWidgetModel = {
    componentView: FigureViewComponent,
    componentControl: FigureControlComponent,
    name: Widgets.FIGURE,
    label: 'widget_figure_label',
    data: figureData,
    permission: defaultWidgetPermission,
    params: { ...defaultWidgetParams, type: ['zero'] },
    // Control + view components own the form via `WebLegacyWidgetSignalFormService`;
    // the resolver takes the minimal load path (just `widget` / `isSpecific` /
    // `isEduSite` — no `widget$`, no `container$`, no `controlForm`).
    signalForm: true,
};
